import type { MotionLevel } from '../settings';

export interface MotionProfile {
  /** Multiplies the baseline particle velocity generated by ParticleField. */
  particleSpeedMultiplier: number;
  /** Maximum pointer/touch parallax displacement from the resting position. */
  parallaxAmplitudePx: number;
  /** Vertical travel of the floating service-card animation. */
  cardFloatDistancePx: number;
  /** Duration of one alternate service-card animation leg. */
  cardFloatDurationMs: number;
}

export const MOTION_PROFILES = {
  off: {
    particleSpeedMultiplier: 0,
    parallaxAmplitudePx: 0,
    cardFloatDistancePx: 0,
    cardFloatDurationMs: 0,
  },
  low: {
    particleSpeedMultiplier: 0.5,
    parallaxAmplitudePx: 6,
    cardFloatDistancePx: 1.5,
    cardFloatDurationMs: 6500,
  },
  medium: {
    particleSpeedMultiplier: 1,
    parallaxAmplitudePx: 12,
    cardFloatDistancePx: 3,
    cardFloatDurationMs: 4500,
  },
  high: {
    particleSpeedMultiplier: 1.5,
    parallaxAmplitudePx: 18,
    cardFloatDistancePx: 4.5,
    cardFloatDurationMs: 3200,
  },
  maximum: {
    particleSpeedMultiplier: 2,
    parallaxAmplitudePx: 24,
    cardFloatDistancePx: 6,
    cardFloatDurationMs: 2200,
  },
} as const satisfies Record<MotionLevel, MotionProfile>;
